<template>
  <div id="klimaPartner" class="animated fadeIn">
    <!-- mobile view -->
    <div class="clearfix fullHeight">
      
      <div class="col-12 lg-col-4 md-col-9 py3 mx-auto shadow mt3">
        <div class="clearfix primarycolor flex justify-start items-center pointer mb3" @click="goToCheckList()">
          <span class="mr1"><i class="el-icon-back"></i></span>
          <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
        </div>
        <div v-if="showMobile" class="col-12 flex justify-between items-center">
          <!-- back button -->
          <div @click="$router.go(-1)" class="clearfix primarycolor flex justify-start items-center">
            <span class="mr1"><i class="el-icon-back"></i></span>
            <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
          </div>
          <!-- opdater -->
          <div class="clearfix primarycolor flex justify-start items-center">
            <span class="mr1"><i class="el-icon-refresh-right"></i></span>
            <span class="h5 gibson line-height-1 m0 p0">Opdater</span>
          </div>
        </div>
        <div class="mt3 px2" v-if="!entrySurvey">
          <p class="h5 textgrey custom-letter-spacing gibson line-height-3">
            Hvilke enheder skal indgå i projektets klimarapport? Du angiver hvilke nøgletal enheden og projektet som helhed bidrager til.
          </p>
        </div>
        <form-wizard ref="wizard" title="" v-if="!success" subtitle="" shape="square" finishButtonText="Bekræft" color="" error-color="#ff4949" class="px1">
          <tab-content title="1" v-if="!entrySurvey" :before-change="validateFirstStep" class="klima-plan">
            <div class="highlights p3 klimaForm">
              <!-- header -->
              <p class="h5 gibson darkblue line-height-1 m0 p0">
                Klima Plan
              </p>
              <div class="py2"></div>
              <!-- single item for form with dropdown -->
              <div class="clearfix" v-if="taskLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else>
                <!-- If userplanId not zero -->
                <div v-for="(task,index) in taskData" :key="index">
                  <div :id="'task-' + task.userplanId" class="clearfix task" v-if="task.userplanId != '0'">
                    <div class="col-12 mb2 px0 flex justify-between items-center">
                      <!-- toggle collapse -->
                      <button v-b-toggle="'toggle-' + index" class="toggle-label-btn pl0 border-none white-background darkblue flex justify-start items-center" @click="validateAllAcceptButton()">
                        <span class="when-opened mr1">
                          <i class="el-icon-caret-bottom mediumgrey"></i>
                        </span>
                        <span class="when-closed mr1">
                          <i class="el-icon-caret-right darkblue"></i>
                        </span>
                        <p class="h5 m0 p0 regular gibson darkblue line-height-1 caps">
                          {{task.title}}
                        </p>
                      </button>
                      <!-- green status shapes -->
                      <div class="types-initial flex justify-end items-center">
                        <span id="economy" class="inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide">
                          Ø
                        </span>
                        <span id="social" class="inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide">
                          S
                        </span>
                        <span id="environment" class="inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide">
                          M
                        </span>
                        <el-switch class="no-events" active-class="darkblue"></el-switch>
                      </div>
                    </div>
                    <!-- dropdown -->
                    <b-collapse :id="'toggle-' + index">
                      <div class="py2 border-top form-border type-tabs">
                        <el-tabs>
                          <el-tab-pane v-if="typeData.main[0].economy.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/money-green.svg" class="economy-img block" width="100%">
                                <span class="bold darkblue">Økonomi</span>
                              </div>
                            </div>
                            <div>
                              <span>Enheden påvirker at:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 relative z2" v-for="(economy, index1) in typeData.main[0].economy" :key="index1" v-if="!economy.onlyOverall && economy.value != 0">
                                  <input :id="'checkbox-' + economy.economicId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('economy', task.userplanId, 'task')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveyEconomy[economy.economicId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{economy.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="typeData.main[0].social.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/money-green.svg" class="economy-img block" width="100%">
                                <span class="bold darkblue">Social</span>
                              </div>
                            </div>
                            <div>
                              <span>Enheden påvirker at:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 relative z2" v-for="(social, index2) in typeData.main[0].social" :key="index2" v-if="!social.onlyOverall && social.value != 0">
                                  <input :id="'checkbox-' + social.socialId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('social', task.userplanId, 'task')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveySocial[social.socialId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{social.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="typeData.main[0].environment.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/leaf-green.svg" class="environment-img block" width="100%">
                                <span class="bold darkblue">Miljø</span>
                              </div>
                            </div>
                            <div>
                              <span>Enheden påvirker at:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 z2" v-for="(environment, index3) in typeData.main[0].environment" :key="index3" v-if="!environment.onlyOverall && environment.value != 0">
                                  <input :id="'checkbox-' + environment.environmentId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('environment', task.userplanId, 'task')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveyEnvironment[environment.environmentId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{environment.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                        </el-tabs>
                        <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" v-b-toggle="'toggle-' + index" @click="getSelectedSurvey(task.userplanId, task.title, 'notZeroPlanId')">
                          <span>ACCEPTER</span>
                          <span class="pl1"><i class="el-icon-right bold"></i></span>
                        </button>
                      </div>
                    </b-collapse>
                  </div>
                  <!-- If userplanId is zero -->
                  <div :id="'task-' + index" class="clearfix task" v-else>
                    <div class="col-12 mb2 px0 flex justify-between items-center">
                      <!-- toggle collapse -->
                      <button v-b-toggle="'toggle-' + index" class="toggle-label-btn pl0 border-none white-background darkblue flex justify-start items-center" @click="validateAllAcceptButton()">
                        <span class="when-opened mr1">
                          <i class="el-icon-caret-bottom mediumgrey"></i>
                        </span>
                        <span class="when-closed mr1">
                          <i class="el-icon-caret-right darkblue"></i>
                        </span>
                        <p class="h5 m0 p0 regular gibson darkblue line-height-1 caps">
                          {{task.title}}
                        </p>
                      </button>
                      <!-- green status shapes -->
                      <div class="types-initial flex justify-end items-center">
                        <span id="economy" class="inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide">
                          Ø
                        </span>
                        <span id="social" class="inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide">
                          S
                        </span>
                        <span id="environment" class="inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide">
                          M
                        </span>
                        <el-switch class="no-events" active-class="darkblue"></el-switch>
                      </div>
                    </div>
                    <!-- dropdown -->
                    <b-collapse :id="'toggle-' + index">
                      <div class="py2 border-top form-border type-tabs">
                        <el-tabs>
                          <el-tab-pane v-if="typeData.main[0].economy.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/money-green.svg" class="economy-img block" width="100%">
                                <span class="bold darkblue">Økonomi</span>
                              </div>
                            </div>
                            <div>
                              <span>Enheden påvirker at:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 relative z2" v-for="(economy, index1) in typeData.main[0].economy" :key="index1" v-if="!economy.onlyOverall && economy.value != 0">
                                  <input :id="'checkbox-' + economy.economicId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('economy', index, 'task')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveyEconomy[economy.economicId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{economy.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="typeData.main[0].social.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/money-green.svg" class="economy-img block" width="100%">
                                <span class="bold darkblue">Social</span>
                              </div>
                            </div>
                            <div>
                              <span>Enheden påvirker at:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 relative z2" v-for="(social, index2) in typeData.main[0].social" :key="index2" v-if="!social.onlyOverall && social.value != 0">
                                  <input :id="'checkbox-' + social.socialId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('social', index, 'task')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveySocial[social.socialId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{social.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="typeData.main[0].environment.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/leaf-green.svg" class="environment-img block" width="100%">
                                <span class="bold darkblue">Miljø</span>
                              </div>
                            </div>
                            <div>
                              <span>Enheden påvirker at:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 z2" v-for="(environment, index3) in typeData.main[0].environment" :key="index3" v-if="!environment.onlyOverall && environment.value != 0">
                                  <input :id="'checkbox-' + environment.environmentId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('environment', index, 'task')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveyEnvironment[environment.environmentId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{environment.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                        </el-tabs>
                        <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" v-b-toggle="'toggle-' + index" @click="getSelectedSurvey(index, task.title, 'zeroPlanId')">
                          <span>ACCEPTER</span>
                          <span class="pl1"><i class="el-icon-right bold"></i></span>
                        </button>
                      </div>
                    </b-collapse>
                  </div>
                </div>
                <div class="border-top form-border mb2">
                </div>
                <div id="task-gathered" class="clearfix">
                    <div class="col-12 mb2 px0 flex justify-between items-center">
                      <!-- toggle collapse -->
                      <button v-b-toggle="'projektet-samlet'" class="toggle-label-btn pl0 border-none white-background darkblue flex justify-start items-center" @click="validateAllAcceptButton()">
                        <span class="when-opened mr1">
                          <i class="el-icon-caret-bottom mediumgrey"></i>
                        </span>
                        <span class="when-closed mr1">
                          <i class="el-icon-caret-right darkblue"></i>
                        </span>
                        <p class="h5 m0 p0 regular gibson darkblue line-height-1">
                          PROJEKTET SAMLET
                        </p>
                      </button>
                      <!-- green status shapes -->
                      <div class="flex justify-end items-center">
                        <el-switch class="no-events" active-class="darkblue"></el-switch>
                      </div>
                    </div>
                    <!-- dropdown -->
                    <b-collapse :id="'projektet-samlet'">
                      <div class="py2 border-top form-border project-tabs">
                        <el-tabs>
                          <el-tab-pane v-if="typeData.main[0].economy.length > 0">
                            <div slot="label" class="flex items-center col-12">
                              <div class="col-12 pt2">
                                <img src="static/svg/money-green.svg" class="economy-img block" width="100%">
                                <span class="bold darkblue">Økonomi</span>
                              </div>
                            </div>
                            <div>
                              <span>Under projektet vil:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 relative z2" v-for="(economy, index1) in typeData.main[0].economy" :key="index1" v-if="economy.onlyOverall && economy.value != 0">
                                  <input :id="'checkbox-' + economy.economicId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('economy', 'gathered', 'project')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveyEconomy[economy.economicId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{economy.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="typeData.main[0].social.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/people-green.svg" class="economy-img block" width="100%">
                                <span class="bold darkblue">Social</span>
                              </div>
                            </div>
                            <div>
                              <span>Under projektet vil:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 relative z2" v-for="(social, index2) in typeData.main[0].social" :key="index2" v-if="social.onlyOverall && social.value != 0">
                                  <input :id="'checkbox-' + social.socialId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('social', 'gathered', 'project')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveySocial[social.socialId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{social.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="typeData.main[0].environment.length > 0">
                            <div slot="label" class="flex items-center p3">
                              <div class="col-12 pt2">
                                <img src="static/svg/leaf-green.svg" class="environment-img block" width="100%">
                                <span class="bold darkblue">Miljø</span>
                              </div>
                            </div>
                            <div>
                              <span>Under projektet vil:</span>
                              <div class="mb2"></div>
                              <div class="flex flex-wrap justify-center mb4">
                                <div class="col-4 white-background itemSelect gibson center p0 mb4 z2" v-for="(environment, index3) in typeData.main[0].environment" :key="index3" v-if="environment.onlyOverall && environment.value != 0">
                                  <input :id="'checkbox-' + environment.environmentId" type="checkbox" class="col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;" @change="selectSurvey('environment', 'gathered', 'project')">
                                  <label class="green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1" style="border-width: 3px !important;">
                                    <img :src="iconData.KlimaSurveyEnvironment[environment.environmentId].icon" class="h1 semi-bold" width="100%">
                                  </label>
                                  <span class="green caps">{{environment.title}}</span>
                                </div>
                                <div class="absolute">
                                  <div class="flex">
                                    <p class="mediumgrey mr1">Ingen data.</p>
                                    <a class="semi-bold primarycolor pointer no-hover" @click="gotoSurvey()">Rediger tjekliste</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                      <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" v-b-toggle="'projektet-samlet'" @click="getSelectedGatheredSurvey('gathered', '')">
                        <span>ACCEPTER</span>
                        <span class="pl1"><i class="el-icon-right bold"></i></span>
                      </button>
                    </b-collapse>
                  </div>
              </div>
              <!-- end single item -->
            </div>
          </tab-content>
          <tab-content title="2 ud af 4" v-if="!entrySurvey" :before-change="validateSecondStep">
            <div class="highlights p3 klimaForm">
              <!-- header -->
              <p class="h5 gibson darkblue line-height-1 mb2 p0">
                1. Send spørgeskema til din kunde
              </p>
              <span class="semi-bold textgrey">Din kunde skal besvare et kort spørgeskema for at lave rapporten. Vælg SMS eller email.</span>
              <div class="mb4"></div>
              <div class="flex mb4 justify-between">
                <div class="col-6 itemSelect gibson center relative z2">
                  <input id="checkbox-message" type="checkbox" class="col-12 absolute ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;">
                  <label class="green pointer block center border green-border py1 px2 ml-auto mx-auto relative z1">
                    <i class="h1 el-icon-chat-dot-square m0"></i>
                    <span class="block m0">Sms</span>
                  </label>
                </div>
                 <div class="col-6 itemSelect gibson center relative z2">
                  <input id="checkbox-email" type="checkbox" class="col-12 absolute ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer" style="opacity: 0; display: block !important;">
                  <label class="green pointer block center border green-border py1 px2 ml-auto mx-auto relative z1">
                    <i class="h1 el-icon-message m0"></i>
                    <span class="block m0">Email</span>
                  </label>
                </div>
              </div>
              <p class="h5 gibson darkblue line-height-1 p0">
                2. Udfyld spørgeskema
              </p>
              <span class="semi-bold textgrey">Du bliver tilsendt et spørgeskema på din email, når du klikker Næste.</span>
              <div class="mb4 hide"></div>
              <button class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center hide">
                <span>OK</span>
                <span class="pl1"><i class="el-icon-right bold"></i></span>
              </button>
            </div>
          </tab-content>
          <tab-content title="3 ud af 4">
            <div class="highlights p3 klimaForm center">
              <div class="clearfix" v-if="taskLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else>
                <div class="py3 mb4">
                  <span class="h4 gibson green line-height-1 mb2 p0 block" v-if="entrySurvey">
                    Spørgeskema sendt
                  </span>
                  <span class="h4 gibson darkblue line-height-1 mb2 p0 block" v-else>
                    Spørgeskema sendt
                  </span>
                  <span class="h4 gibson green line-height-1 mb2 p0 block" v-if="partnerSurvey">
                    Besvar spørgeskema
                  </span>
                  <span class="h4 gibson darkblue line-height-1 mb2 p0 block" v-else>
                    Besvar spørgeskema
                  </span>
                  <span class="h4 gibson green line-height-1 mb2 p0 block" v-if="customerSurvey">
                    Afvent besvarelse
                  </span>
                  <span class="h4 gibson darkblue line-height-1 mb2 p0 block" v-else>
                    Afvent besvarelse
                  </span>
                </div>
                <div class="py3">
                  <span class="h5 gibson green line-height-1 mb1 p0 block">
                   Hvad skal du gøre?
                  </span>
                  <span class="h5 gibson mediumgrey line-height-1 mb2 p0 block">Udfyld dit spørgeskema, og bed din kunde til at udfylde sit. Så kan klimarapporten beregnes.</span>
                </div>
              </div>
            </div>
          </tab-content>
          <div class="flex justify-start items-center col-12 px0 mt3 mb2" v-if="!entrySurvey">
            <div class="col-4 px1">
              <el-progress :percentage="progressbar[0].progress1" :show-text=false color="#4dcf55"></el-progress>
            </div>
            <div class="col-4 px1">
              <el-progress :percentage="progressbar[0].progress2" :show-text=false color="#4dcf55"></el-progress>
            </div>
            <div class="col-4 px1">
              <el-progress :percentage="progressbar[0].progress3" :show-text=false color="#4dcf55"></el-progress>
            </div>
            
          </div>
          <template slot="footer" slot-scope="props" v-if="!entrySurvey && !taskLoading">
            <div class="wizard-footer-left flex-auto">
              <wizard-button v-if="!props.isLastStep" @click.native="props.prevTab(), tlføjEnhedVisible = true" class="flex items-start justify-start">
                <span class="block flex flex-column justify-start items-start">
                  <span class="block flex justify-start">
                    <i class="el-icon-back"></i>
                  </span>
                  <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">Tilbage</span>
                </span>
              </wizard-button>
              <!-- <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle">Previous</wizard-button> -->
            </div>
            <div class="flex flex-column justify-center items-center gibson pointer" v-if="tlføjEnhedVisible">
              <template>
                <div @click="unitDialogVisible = true" class="mx-auto center border darkblue-border" style="height:48px;width:48px;border-radius:50%;line-height:48px;border:2px solid!important;">
                  <span class="green semi-bold" style="font-size:24px;"><i class="el-icon-plus"></i></span>
                </div>
              </template>
              <span class="center block h6 caps gibson darkblue line-height-1 mt2 mb0 p0">Tilføj enhed</span>
            </div>
            <div class="wizard-footer-right flex-auto">
              <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="flex flex-column items-end justify-end px0 col-12">
                <span class="block flex flex-column justify-end items-end">
                  <span class="block flex justify-end"><i class="el-icon-right"></i></span>
                  <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">Næste</span>
                </span>
              </wizard-button>
            </div>
          </template>
        </form-wizard>
        <!-- <b-sidebar width="414px" id="addUnit" sidebar-class="" body-class="inner border-none relative unitSidebar">
          <div class="clearfix px2 pt3">
            <div class="mx-auto center" style="height:48px;width:48px;border-radius:50%;line-height:48px;border:2px solid white;">
              <span class="white semi-bold" style="font-size:24px;"><i class="el-icon-plus"></i></span>
            </div>
            <p class="h2 regular center darkblue gibson line-height-2 my2">
              Enhed
            </p>
            <div>
              <input type="text" v-model="taskTitle" placeholder="F. eks. isolering" class="col-12 white-background border-none not-rounded gibson h5 line-height-1 p2">
            </div>
            <div class="clearfix white-background p2 col-12 pointer">
              <el-checkbox class="flex justify-start items-center h4 regular darkblue gibson line-height-1 m0 p0" v-model="checked">Tilføj pris</el-checkbox>
            </div>
            <div class="clearfix white-background p1" v-if="checked == true">
              <div style="border: 1px solid rgba(178, 190, 195, 1);">
                
                <div class="col-12 px0 flex justify-start items-start">
                  <div class="col-7 px1 flex jusify-start items-center" style="border-right:1px solid rgba(178, 190, 195, 1);">
                    <span class="h6 darkblue gibson line-height-1 mx2 my0 p0">
                      Antal
                    </span>
                    <el-input placeholder="0" v-model="antal" class="darkblue gibson"></el-input>
                  </div>
                  <div class="col-5 px1 flex jusify-start items-center">
                    <span class="h6 darkblue gibson line-height-1 mx2 my0 p0">
                      Type
                    </span>
                    <el-select v-model="value" placeholder="Select">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div> -->
                <!-- next row -->
                <!-- <div class="col-12 px1 flex justify-start items-center" style="border-top: 1px solid rgba(178, 190, 195, 1);">
                  <span class="h6 darkblue gibson line-height-1 mx2">Pris</span>
                  <el-input placeholder="Please input" v-model="price"></el-input>
                </div>
              </div>
              <div class="py1"></div>
              <div style="border: 1px solid rgba(178, 190, 195, 1);">
                <div class="col-12 px0 py2" style="border-bottom:1px solid rgba(178,190,195,1);">
                  <div class="flex justify-between items-center px2">
                    <span class="h6 darkblue gibson line-height-1 m0 p0">
                    Enhedspris eksl. moms</span>
                    <span class="h6 darkblue gibson line-height-1 m0 p0">0,00 kr</span>
                  </div>
                </div>
                <div class="col-12 px0 py2" style="border-bottom:1px solid rgba(178,190,195,1);">
                  <div class="flex justify-between items-center px2">
                    <span class="h6 darkblue gibson line-height-1 m0 p0">
                    25% moms</span>
                    <span class="h6 darkblue gibson line-height-1 m0 p0">0,00 kr</span>
                  </div>
                </div>
                <div class="col-12 px0 py2">
                  <div class="flex justify-between items-center px2">
                    <span class="h6 darkblue gibson line-height-1 m0 p0">
                    Enhedspris inkl. moms</span>
                    <span class="h6 darkblue gibson line-height-1 m0 p0">0,00 kr</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt2">
              <button v-b-toggle.addUnit class="action-button p2 h4 gibson regular line-height-1 col-12 flex justify-center items-center" v-b-toggle.values>
                <span>OK</span>
                <span class="pl1"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <div class="hide col-10 mx-auto white-background p2 flex justify-center items-center border-none light-highlights">
              <span class="col-8 px0 right-align px0inline-block h4 regular m0 py0 gibson darkblue line-height-1 px1">
                {{EL1}}
              </span>
              <span class="col-4 inline-block h4 regular m0 py0 gibson lightgrey line-height-1 px1">
                KW H
              </span>
            </div>
          </div>
        </b-sidebar> -->
        <div v-if="!showMobile" style="height:200px;"></div>
      </div>
    </div>
    <el-dialog
      title="Warning"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>It should be noted that the content will not be aligned in center by default</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="unitDialogVisible" width="60%" center class="unitDialog">
      <div class="clearfix center px2 pt3">
        <div class="mx-auto center" style="height:48px;width:48px;border-radius:50%;line-height:48px;border:2px solid white;">
          <span class="white semi-bold" style="font-size:24px;"><i class="el-icon-plus"></i></span>
        </div>
        <p class="h2 regular darkblue gibson line-height-2 my2">
          Enhed
        </p>
        <div>
          <input type="text" v-model="taskTitle" placeholder="F. eks. isolering" class="col-12 white-background border-none not-rounded gibson h5 line-height-1 p2">
        </div>
        <div>
          <button @click="addTask()" class="action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center" v-b-toggle.values>
            <span>OK</span>
            <span class="pl1"><i class="el-icon-right"></i></span>
          </button>
        </div>
        <div class="hide col-10 mx-auto white-background p2 flex justify-center items-center border-none light-highlights">
          <span class="col-8 px0 right-align px0inline-block h4 regular m0 py0 gibson darkblue line-height-1 px1">
            {{EL1}}
          </span>
          <span class="col-4 inline-block h4 regular m0 py0 gibson lightgrey line-height-1 px1">
            KW H
          </span>
        </div>
      </div>
      <span slot="footer" class="hide dialog-footer"></span>
    </el-dialog>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { NumericKeyboard, Keys } from 'numeric-keyboard'
import Dropzone from 'vue2-dropzone'
import fileUploadInput from '../../../components/file-upload-input'
import Simplert from 'vue2-simplert'
export default {
  name: 'klima',
  components: {
    loading,
    NumericKeyboard,
    Keys,
    Dropzone,
    FormWizard,
    TabContent,
    fileUploadInput,
    Simplert
  },
  props: ['projects', 'projects_create'],
  data () {
    return {
      'vue/no-use-v-if-with-v-for': ['error', {
        'allowUsingIterationVar': true
      }],
      taskLoading: true,
      salesPerson: '',
      haaId: '',
      price: '',
      checked: null,
      antal: '',
      options: [{
        value: 'Option1',
        label: 'Option1'
      }, {
        value: 'Option2',
        label: 'Option2'
      }, {
        value: 'Option3',
        label: 'Option3'
      }, {
        value: 'Option4',
        label: 'Option4'
      }, {
        value: 'Option5',
        label: 'Option5'
      }],
      addUnit: '',
      unitDialogVisible: false,
      bDialogVisible: false,
      el1DialogVisible: false,
      centerDialogVisible: false,
      description: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      success: false,
      tasktype: [],
      title: '',
      validationType: '',
      validationTitle: '',
      validationDescription: '',
      // from klimaplan.vue
      EL1modal: false,
      EL2modal: false,
      B1modal: false,
      EL1: '',
      EL2: '',
      C: '',
      AF: '',
      B: '',
      B1: '',
      isOpen: false,
      isWindow1: false,
      value: '',
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      targetId: '',
      isSelected: false,
      amount: '',
      valuesInput: false,
      max: 4,
      filesDropzone: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 7.5,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="flex justify-center items-center"><span class="inline-block green mr1"><i class="h4 el-icon-upload"></i></span><span class="inline-block h5 m0 p0 gibson line-height-1">Upload</span></div>'
      },
      taskData: [],
      typeData: [],
      taskTitle: '',
      selectedTypeData: [],
      is: 'is',
      isData: [],
      klimaId: '',
      contactId: '',
      offer: '',
      test: '',
      documents: [
        {
          fileList: []
        },
        {
          fileList: []
        },
        {
          fileList: []
        }
      ],
      allUserPlan: [],
      gatheredUserPlan: [],
      progressbar: [
        {
          progress1: 100,
          progress2: 0,
          progress3: 0
        }
      ],
      entrySurvey: true,
      customerSurvey: true,
      partnerSurvey: true,
      draft: '',
      iconData: [],
      openCollapse: false,
      tlføjEnhedVisible: true
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    if (localStorage.getItem('climate') === 'false') {
      setTimeout(() => {
        document.getElementById('klimaPartner').classList.add('hide')
      }, 50)
    }
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    var appointmentId = searchParams.get('appointmentId')
    this.appointmentId = appointmentId
    var klimaId = searchParams.get('klimaId')
    this.klimaId = klimaId
    var contactId = searchParams.get('contactId')
    this.contactId = contactId
    var draft = searchParams.get('draft')
    this.draft = draft
    this.getKlimaStatus()
    setTimeout(() => {
      var btn = document.querySelectorAll('.klima-documentation > .input-group > button')
      for (var i = 0; i < btn.length; i++) {
        btn[i].innerHTML = '<button class="action-button p2 h4 col-12 gibson regular line-height-1 flex justify-center items-center border rounded"><span class="mr2"><i class="el-icon-paperclip"></i></span><span>VEDHÆFTET</span></button>'
      }
    }, 1000)
  },
  dropzoneSettings () {
    let defaultValues = {
      thumbnailWidth: 200,
      thumbnailHeight: 200
    }
    Object.keys(this.options).forEach(function (key) {
      defaultValues[key] = this.options[key]
    }, this)
    if (this.awss3 !== null) {
      defaultValues['autoProcessQueue'] = false
      this.isS3 = true
      if (this.options.autoProcessQueue !== undefined) {
        this.wasQueueAutoProcess = this.options.autoProcessQueue
      }
    }
    return defaultValues
  },
  methods: {
    goToCheckList () {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    },
    showModal () {
      this.$root.$emit('bv::show::modal', 'EL1modal', '#btnShow')
    },
    isLastStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    validateFirstStep () {
      var checkSwitch = document.querySelectorAll('.klima-plan .el-switch')
      var checkedCount = 0
      for (var i = 0; i < checkSwitch.length; i++) {
        if (checkSwitch[i].classList.contains('is-checked')) {
          checkedCount++
        }
      }
      var validation = ''
      var draft = parseInt(this.draft)
      if (draft === 1) {
        draft = 0
      }
      if (checkedCount === checkSwitch.length && !this.openCollapse) {
        var data = {
          operation: 'klimaApi',
          salesPerson: this.salesPerson,
          levid: this.haaId,
          ContactId: this.contactId,
          CompanyId: this.haaId,
          parameters: JSON.stringify({
            draft: draft,
            klimaId: this.klimaId,
            operation: 'addKlima',
            ContactId: this.contactId,
            CompanyId: this.haaId,
            info: '',
            offerId: this.offer,
            userplan: this.allUserPlan,
            usersurvey: this.gatheredUserPlan
          })
        }
        this.$http.post('', data, { emulateJSON: true }).then(
          response => {
            var res = response.body
            if (res.success) {
            } else {
              this.$toastr('error', 'Error in validateFirstStep()')
            }
          },
          response => {
            this.$toastr('error', 'Error in validateFirstStep()')
          }
        )
        this.progressbar[0].progress2 = 100
        this.tlføjEnhedVisible = false
        validation = true
      } else if (checkedCount !== checkSwitch.length) {
        validation = false
        this.$toastr('error', 'Felter påkrævet')
      } else if (this.openCollapse) {
        validation = false
        this.$toastr('error', 'Klik på knappen Accepter')
      }
      return validation
    },
    validateSecondStep () {
      var inputMsg = document.querySelector('#checkbox-message')
      var inputEmail = document.querySelector('#checkbox-email')
      var validation = ''
      if (inputMsg.checked === true || inputEmail.checked === true) {
        if (inputMsg.checked === true) {
          this.sendCustomerQuestionnaire('sms')
        }
        if (inputEmail.checked === true) {
          this.sendCustomerQuestionnaire('email')
        }
        this.sendPartnerQuestionnaire()
        this.progressbar[0].progress3 = 100
        this.taskLoading = true
        validation = true
      } else {
        validation = false
        this.$toastr('error', 'Vælg en indstilling')
      }
      return validation
    },
    onComplete () {
      var validation = true
      let obj = {
        title: 'Gennemført!',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
      this.taskLoading = false
      return validation
    },
    updateEL1 (event) {
      const value = event.target.value
      console.log(value, this.EL1)
      if (String(value).length <= 4) {
        this.EL1 = value
      }
      this.$forceUpdate()
    },
    updateEL2 (event) {
      const value = event.target.value
      console.log(value, this.EL2)
      if (String(value).length <= 4) {
        this.EL2 = value
      }
      this.$forceUpdate()
    },
    select: function (event) {
      var targetId = this.targetId
      targetId = event.currentTarget.id
      console.log(targetId)
    },
    pressEL1 (key) {
      if (key === Keys.DEL) {
        this.EL1 = this.EL1.slice(0, -1)
      } else {
        this.EL1 = this.EL1 + key
        if (this.EL1.length === 4) {
          setTimeout(() => this.$emit('confirm', this.EL1), 100)
        }
      }
    },
    pressEL2 (key) {
      if (key === Keys.DEL) {
        this.EL2 = this.EL2.slice(0, -1)
      } else {
        this.EL2 = this.EL2 + key
        if (this.EL2.length === 4) {
          setTimeout(() => this.$emit('confirm', this.EL2), 100)
        }
      }
    },
    confirmAmount () {
      if (this.EL1) {
        console.log(this.EL1)
      }
    },
    confirm () {
      let obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<p class="h3 mt3 regular gibson darkblue line-height-2" style="text-align:left;">Din klima plan er færdig</p>',
        /* title: 'Gennemført!', */
        /* message: '', */
        type: 'success',
        customCloseBtnClass: 'primary-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    },
    delItem () {
      let obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<p class="h3 mt3 regular gibson darkblue line-height-2" style="text-align:left;">Din klima plan er færdig</p>',
        /* title: 'Gennemført!', */
        /* message: '', */
        type: 'success',
        customCloseBtnClass: 'primary-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    },
    displayType () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: JSON.stringify({
          operation: 'getUserSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          // console.log('displayType', res)
          this.typeData = res.data
          this.getKlimaIcons()
        },
        (response) => {
          this.$toastr('error', 'Error in displayType()')
        }
      )
    },
    displayTask () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getKlima'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            console.log('🚀 ~ file: klima.vue ~ line 1054 ~ displayTask ~ this.taskData', res)
            var dataArr = ''
            if (this.draft === '0') {
              dataArr = res.data.main
            } else {
              dataArr = res.data.draft
            }
            for (var i = 0; i < dataArr.length; i++) {
              if (dataArr[i].klimaId === this.klimaId) {
                this.offer = dataArr[i].offer
                this.taskData = dataArr[i].user_group
                this.displayType()
              }
            }
          } else {
            this.$toastr('error', 'Error in displayTask()')
          }
        },
        response => {
          this.$toastr('error', 'Error in displayTask()')
        }
      )
    },
    handleFileUpload (file) {
      this.documentList = file
    },
    selectSurvey (type, planId, section) {
      if (section === 'task') {
        this.checkInitialType(type, planId)
      }
      this.checkSwitch(type, planId)
    },
    checkInitialType (type, planId) {
      var val = document.querySelector('#task-' + planId + ' .el-tabs__item.is-active').id.split('-')
      var id = val[1]
      var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id + ' .itemSelect input')
      var checkedCount = 0
      for (var i = 0; i < input.length; i++) {
        if (input[i].checked === true) {
          checkedCount++
        }
      }
      if (checkedCount > 0) {
        document.querySelector('#task-' + planId + ' .types-initial #' + type).classList.remove('hide')
      } else {
        document.querySelector('#task-' + planId + ' .types-initial #' + type).classList.add('hide')
      }
    },
    checkSwitch (type, planId) {
      var val = document.querySelectorAll('#task-' + planId + ' .el-tabs__item')
      var checkedCount = 0
      for (var i = 0; i < val.length; i++) {
        var id = val[i].id.split('-')
        var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id[1] + ' .itemSelect input')
        for (var x = 0; x < input.length; x++) {
          if (input[x].checked === true) {
            checkedCount++
          }
        }
        if (checkedCount > 0) {
          document.querySelector('#task-' + planId + ' .el-switch').classList.add('is-checked')
        } else {
          document.querySelector('#task-' + planId + ' .el-switch').classList.remove('is-checked')
        }
      }
    },
    getSelectedSurvey (planId, planTitle, planIdType) {
      var val = document.querySelectorAll('#task-' + planId + ' .el-tabs__item')
      var userSurvey = []
      for (var i = 0; i < val.length; i++) {
        var id = val[i].id.split('-')
        var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id[1] + ' .itemSelect input')
        for (var x = 0; x < input.length; x++) {
          if (input[x].checked === true) {
            var surveyId = input[x].id.split('-')
            userSurvey.push(parseInt(surveyId[1]))
          }
        }
      }
      if (planIdType === 'notZeroPlanId') {
        planId = parseInt(planId)
      } else if (planIdType === 'zeroPlanId') {
        planId = 0
      }
      this.allUserPlan.push({
        userplanId: planId,
        title: planTitle,
        files: [],
        images: [],
        info: '',
        usertype: [],
        usersurvey: userSurvey
      })
      this.validateAllAcceptButton()
    },
    getSelectedGatheredSurvey (planId, planTitle) {
      var val = document.querySelectorAll('#task-' + planId + ' .el-tabs__item')
      var userGatheredSurvey = []
      for (var i = 0; i < val.length; i++) {
        var id = val[i].id.split('-')
        var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id[1] + ' .itemSelect input')
        for (var x = 0; x < input.length; x++) {
          if (input[x].checked === true) {
            var surveyId = input[x].id.split('-')
            userGatheredSurvey.push(parseInt(surveyId[1]))
          }
        }
      }
      this.gatheredUserPlan = userGatheredSurvey
      this.validateAllAcceptButton()
    },
    validateAllAcceptButton () {
      setTimeout(() => {
        var collapseBtn = document.querySelectorAll('.klima-plan .collapse')
        this.openCollapse = false
        for (var i = 0; i < collapseBtn.length; i++) {
          if (collapseBtn[i].classList.contains('show')) {
            this.openCollapse = true
          }
        }
      }, 500)
    },
    sendCustomerQuestionnaire (type) {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          klimaId: this.klimaId,
          operation: 'sendForm',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          type: type,
          to: 'customer'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
          } else {
            this.$toastr('error', 'Error in sendCustomerQuestionnaire()')
          }
        },
        response => {
          this.$toastr('error', 'Error in sendCustomerQuestionnaire()')
        }
      )
    },
    sendPartnerQuestionnaire () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          klimaId: this.klimaId,
          operation: 'sendForm',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          type: 'email',
          to: 'partner'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.getKlimaStatus()
            this.onComplete()
          } else {
            this.$toastr('error', 'Error in sendPartnerQuestionnaire()')
          }
        },
        response => {
          this.$toastr('error', 'Error in sendPartnerQuestionnaire()')
        }
      )
    },
    getKlimaStatus () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'klimaStatus',
          CompanyId: this.haaId,
          ContactId: this.contactId,
          klimaId: this.klimaId,
          to: 'customer'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.entrySurvey = res.data.EntrySurvey
            this.customerSurvey = res.data.CustomerSurvey
            this.partnerSurvey = res.data.PartnerSurvey
            this.displayTask()
          } else {
            this.$toastr('error', 'Error in getKlimaStatus()')
          }
        },
        response => {
          this.$toastr('error', 'Error in getKlimaStatus()')
        }
      )
      // this.taskLoading = true
    },
    addTask () {
      if (this.taskTitle !== '') {
        var titleExist = false
        for (var i = 0; i < this.taskData.length; i++) {
          if (this.taskData[i].title === this.taskTitle) {
            titleExist = true
          }
        }
        if (!titleExist) {
          this.taskData.push(
            {
              userplanId: '0',
              title: this.taskTitle,
              file: [],
              fileList: [],
              image: [],
              imageList: [],
              user_type: [],
              user_survey: [],
              info: ''
            })
          this.taskTitle = ''
          this.unitDialogVisible = false
          this.$toastr('success', 'Tilføjet')
        } else {
          this.$toastr('error', 'Eksisterer allerede')
        }
      } else {
        this.$toastr('error', 'Felt kræves')
      }
    },
    getKlimaIcons () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getSurveyicon'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.iconData = res.data
            this.taskLoading = false
          } else {
            this.$toastr('error', 'Error in getIcons()')
          }
        },
        response => {
          this.$toastr('error', 'Error in getIcons()')
        }
      )
    },
    gotoSurvey () {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    }
  },
  watch: {
    'tasktype': function (newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true
      }
    },
    'title': function (newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true
      }
    },
    'description': function (newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true
      }
    }
  },
  computed: {
    el1State () {
      return this.EL1.length > 2
    },
    el2State () {
      return this.EL2.length > 2
    }
  }
}
</script>
<style lang="less">
#klimaPartner .el-tabs__nav {
  width: 100%;
  display: flex;
  justify-content: center;
}
#klimaPartner .el-tabs__item {
  width: 30%;
  height: auto;
  text-align: center;
  padding: 0;
  margin: 0 20px;
  background-color: #EBEFF2;
}
.type-tabs #tab-1 {
  display: none;
}
#klimaPartner .el-tabs__item.is-active {
  color: #fff;
  background-color: #4dcf55;
}
#klimaPartner .el-tabs__item.is-active span {
  color: #fff !important;
}
#klimaPartner .el-tabs__item.is-active img {
  -webkit-filter: invert(1) brightness(100);
  filter: invert(1) brightness(100);
}
#klimaPartner .el-tabs__nav-wrap::after {
  display: none;
}
#klimaPartner .el-tabs__active-bar {
  display: none;
}
#klimaPartner button.toggle-label-btn.not-collapsed {
  pointer-events: none;
}
.unitSidebar {
  .el-input__inner {
    border: none;
    color: rgba(0, 54, 69, 1.0);
    font-size: 1rem;
  }
}
.unitDialog {
  .el-dialog {
    background: transparent!important;
  }
}
.vue-form-wizard .wizard-card-footer {
  display: flex;
  justify-content: between;
  justify-items: center;
  padding:0;
  margin-top:20px;
}
.vue-form-wizard .wizard-btn {
  padding: 0!important;
}
.wizard-tab-content {
  padding-right: 0!important;
  padding-left: 0!important;
}
.wizard-progress-with-circle,
.wizard-nav {
  display: none!important;
}
.modal-footer {
  padding: 0;
}
.modal-header > div:nth-child(1),
.modal-footer > div:nth-child(1) {
  width:100%;
}
.b-sidebar-header {
  border: 0!important;
  border-color: transparent!important;
}
.el-dialog__wrapper,
.b-sidebar-header,
.inner {
  background: rgba(178, 190, 195, 0.75) 0% 0% no-repeat padding-box;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  filter: brightness(-2);
  -webkit-filter: brightnes(-2);
  -moz-filter: brightness(-2)
}
.el-dialog {
  box-shadow: none;
  border-radius: 0;
}
.close {
  height: 24px;
  width: 24px;
  text-align:center;
  line-height: 24px;
  background-color: rgba(0,0,0, 1)!important;
  border-radius: 50%;
  color: white!important;
}
.numeric-keyboard {
  font-family: 'canada-type-gibson'!important;
  font-weight: 400;
  color: rgba(0, 54, 69, 1.0);
}
.numeric-keyboard-key {
  padding: 1rem 0;
}
.itemDot {
  display: inline-block;
  position: relative;
}
.itemDot:after {
  content: '';
  position: absolute;
  left:-4px;
  top:4px;
  height:8px;
  width:8px;
  border-radius: 50%;
  background-color: rgba(0, 54, 69, 1.0);
}
.wizard-header {
  padding: 0!important;
}
.klima-documentation > .input-group > button {
  padding: 0;
  border: none !important;
}
@media only screen and (max-width: 600px) {
  .highlights {
    min-height: 240px;
    max-height: 360px;
    overflow-y:scroll;
  }
}
input[type="text"]:focus,
textarea:focus {
  outline: none;
}
.vue-dropzone {
  width:100%;
  min-height:0;
  padding: 0;
  border: 0;
  background: transparent;
  color: white!important;
  &:hover {
    background: transparent;
  }
  i {
    color: white!important;
  }
}
.dz-preview {
  display: none!important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.klimaForm {
  .itemSelect {
    input[type="checkbox"]:checked+label {
      img {
        filter: invert(1) brightness(100);
      }
    }
  }
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// klima.vue?7d975f0e